import React from 'react';

/**
 * AppFooter - Displays app version in the footer
 * Version is automatically generated at build time
 */
export function AppFooter({ className = '' }) {
  const version = process.env.REACT_APP_VERSION || 'dev';
  
  return (
    <footer className={`py-3 px-4 text-center ${className}`}>
      <p className="text-xs text-slate-400 dark:text-slate-500">
        ViajeJunto v{version}
      </p>
    </footer>
  );
}

/**
 * Inline version badge - for use in menus or settings
 */
export function VersionBadge({ className = '' }) {
  const version = process.env.REACT_APP_VERSION || 'dev';
  
  return (
    <span className={`text-[10px] px-1.5 py-0.5 rounded bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400 font-mono ${className}`}>
      v{version}
    </span>
  );
}

export default AppFooter;
